import { Component, OnInit } from '@angular/core'
import { AuthService } from '../services/auth.service'
import { ExchangeRateService } from '../services/exchange-rate.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-currency-convertor',
  templateUrl: './currency-convertor.component.html',
  styleUrls: ['./currency-convertor.component.css']
})
export class CurrencyConvertorComponent implements OnInit {
  amount: number = 0
  baseCurrency: string = 'BGN'
  targetCurrency: string = 'USD'
  exchangeRate: number = 0
  result: number = 0
  currencies: string[] = ['USD', 'EUR', 'GBP', 'CAD', 'AUD', 'JPY', 'CNY', 'INR', 'BGN']

  constructor(private exchangeRateService: ExchangeRateService, public authService: AuthService, private router: Router) { }

  ngOnInit() {
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['notFound'])
    }
  }

  get getSessionExpired() {
    if (!this.authService.isLoggedIn()) {
      return this.router.navigate(['/login'])
    }
  }

  convert() {
    this.exchangeRateService.getExchangeRate(this.baseCurrency, this.targetCurrency).subscribe((response: any) => {
      if (response.success) {
        this.exchangeRate = response.rates[this.targetCurrency]
        this.result = this.amount / this.exchangeRate
      } else {
        console.error(response.error.info)
      }
    }, (error: any) => {
      console.error(error)
    })
  }
}
